export const DataMutation_Shipping_SetGuestEmail_QueryKey = {
  shippingSetGuestEmail: (): string => {
    const queryKey = "data-mutation--shipping-set-guest-email";
    return queryKey;
  },
};
